import { useCallback, useContext } from 'react';

import useRequest from '@swf/core/hooks/useRequest';
import type {
  GetClubTournamentsStructuresResponse,
  HGGetClubTournStructuresReply
} from '@swf/generated/types/api/v0/SwHomeGames';
import { handleServerResponse } from '@swf/poker';

import CreateTournamentContext from '../CreateTournamentContext/CreateTournamentContext';

const useGetClubTournamentStructures = () => {
  const request = useRequest();
  const {
    state: { clubId }
  } = useContext(CreateTournamentContext);

  return {
    getClubTournamentStructures: useCallback(async () => {
      const { body } = await request({
        service: 'homeGames.getClubTournamentsStructuresRequest',
        body: { getClubTournStructures: { clubId } }
      }).toPromise();

      const tournamentStructuresResponse = handleServerResponse<
        GetClubTournamentsStructuresResponse,
        HGGetClubTournStructuresReply
      >({
        response: body,
        accessor: 'tournamentStructures'
      });

      return { tournamentStructuresResponse, loading: false };
    }, [request, clubId])
  };
};

export default useGetClubTournamentStructures;
